"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketInsightsApi = void 0;
const handlers_1 = require("../handlers");
exports.marketInsightsApi = (http, prefix = '/market-insights') => ({
    getPricingByPropertyId(id) {
        return http.get(`${prefix}/property/${id}/pricing`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.pricing);
    },
    getPricingByLatLng(lat, lng, pax) {
        return http.get(`${prefix}/pricing?lat=${lat}&$lng=${lng}&pax=${pax}`)
            .catch(handlers_1._404({}))
            .then((resp) => resp.pricing);
    }
});
//# sourceMappingURL=index.js.map